import type { ReactNode } from 'react';
import { formatMoneyAr } from './loan-financial.format';

export function Hint({ text }: { text: string }) {
  return (
    <span
      className="ml-1 inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-300 text-[10px] text-slate-500 cursor-help"
      title={text}
      aria-label={text}
    >
      ?
    </span>
  );
}

export function SectionCard({
  title,
  subtitle,
  children,
  actions,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 flex flex-wrap items-start justify-between gap-2">
        <div>
          <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
          {subtitle ? <p className="mt-0.5 text-xs text-slate-500">{subtitle}</p> : null}
        </div>
        {actions}
      </div>
      {children}
    </section>
  );
}

export function MoneyRow({
  label,
  value,
  emphasis,
  tooltip,
}: {
  label: string;
  value: string | number | null | undefined;
  emphasis?: boolean;
  tooltip?: string;
}) {
  const display =
    typeof value === 'string' && /\$|ARS/.test(value)
      ? value
      : formatMoneyAr(value ?? 0);
  return (
    <div
      className={`flex justify-between gap-3 text-sm ${
        emphasis ? 'font-semibold text-slate-900' : 'text-slate-700'
      }`}
    >
      <span>
        {label}
        {tooltip ? <Hint text={tooltip} /> : null}
      </span>
      <span className="tabular-nums">{display}</span>
    </div>
  );
}

export function SkeletonBlock({ className = 'h-20' }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-slate-100 ${className}`} aria-hidden />;
}
